export default __webpack_public_path__ + "static/media/Q11_4_resized.ed17531b.jpg";